export default {"src":"/_next/static/media/icon_earn_prizes.b7be5a0b.svg","height":25,"width":28,"blurWidth":0,"blurHeight":0};